const ja = {
	// 账户余额
	accountBalance: {
		title: '口座残高',
		account: 'アカウント',
		withdraw: '出金',
		balance: '口座残高',
		frozenBalance: '冷凍量',
		RollingReserveBalance: 'ローリング保証金',
		fixedReserveBalance: '固定保証金額',
		availableBalance: '出金可能額',
		availableBalance2: '出金可能残高',
		accountDetail: '口座明細',
		group: 'グループ',
		storeName: 'グループ/サイト',
		storeName1: 'Webサイト',
		businessType: '取引種別',
		revenueExpense: '入出金',
		revenue: '収入',
		expense: '支出',
		transactionId: '元の取引注文番号',
		orderId: 'サイト注文番号',
		time: '決済日時',
		search: '検索',
		clear: 'リセット',
		exportExcel: 'エクスポート',
		balanceAccount: '口座明細',
		frozenAccount: 'アカウントを凍結する',
		RollingReserveAccount: 'リボルビング証拠金口座',
		fixedReserveAccount: '固定証拠金口座',
		amount: '合計金額',
		hideDetail: '詳細を閉じる',
		showDetail: '詳細を表示'
	},
	filter: {
		webSite: 'Webサイト',
		all: '全て',
		status: 'ステータス',
		groupName: 'グループ',
		date: '期間',
		selectDate: '日付を選択してください',
		remitted: '支払いが成功しました',
		remitting: '支払い中です',
		failed: '支払いに失敗しました',
		_return: '返金',
		quicklySelect: {
			lab: 'クイック選択',
			range: {
				today: '今日',
				lastWeek: '先週',
				lastMonth: '先月',
				lastYear: '去年'
			}
		}
	},
	tableColumns: {
		withdrawalTime: '出金日時',
		withdrawalFlowID: '出金番号',
		webSite: 'Webサイト',
		groupName: 'グループ',
		paymentAccount: '振込先口座',
		withdrawalAmount: '出金額',
		withdrawalFee: '出金手数料',
		transferredAmount: '受取金​​額',
		remittanceTime: '送金日時',
		status: 'ステータス',
		orderStatus: '注文状況',
		riskDetail: '詳細',
		noData: 'データなし',
		exportFaild: '情報をエクスポートできませんでした。連絡して後でもう一度お試しください。',
		operator: '担当者',
		riskFieldTips: '評価後、今回出金できる現金の金額は {0} {1} です。もう一度開始してください。',
		receiptBtn: 'クーポンをダウンロードする'
	},
	unsettled: {
		currency: '取引通貨',
		totalAmount: '取引概要金額 (米ドルで計算) は次のとおりです。',
		title: '未決済取引統計',
		view: 'ビュー',
		amount: '合計金額',
		storeName: 'Webサイト / グループ',
		omniStoreName: '店舗/ウェブサイト/グループ',
		orderId: 'サイト注文番号',
		flowId: '取引番号',
		usdAmount: '米ドルに換算した金額',
		transRecord: '未決決済内容の照会',
		time: '取引日時',
		tip: '※このページに記載されている金額はすべて決済対象の取引金額であり、実際の決済金額が優先されます。',
		more: '拡大する',
		collapse: '近い',
	 	totalAmountUSD: '合計金額(USD)',
		amountTip: '以下の集計金額は取引金額であり、手数料等の費用は含まれておりません。'

	},
	withdrawalDetail: {
		title: '出金明細',
		dialogTitle: '出金明細',
		groupName: '対象グループ',
		withdrawalFlowID: '出金番号',
		search: '検索',
		reset: 'リセット'
	}
}
export default ja
